import template from './sesiones-cajas.html';
import { FormActions } from 'core/services/form';
import sesionesCajasI18N from 'i18n/cajas/es.json';
import { fechaHoraRenderer, download } from 'core/util';
import config from 'config.json';
import { formatErrorMessage } from 'core/util';

export let SesionesCajasComponent = {
  templateUrl: template,
  selector: 'sesionesCajas',
  bindings: {
    translations: '='
  },
  controller: SesionesCajasCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamesesiones-cajasnte'
];
export const translationKeys = Object.keys(sesionesCajasI18N).concat(commonsI18N);

SesionesCajasCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', '$stateParams', 'ngNotify', 'Filter', '$resource', 'HeadersUtil', 'AuthorizationService'
];

function SesionesCajasCtrl(BasicFactory, $ngRedux, $state, $stateParams, ngNotify, Filter, $resource, HeadersUtil,
  AuthorizationService) {

  Object.assign(this, { $state, $ngRedux, ngNotify });

  var defaultColumnOrder = ['arqueoCaja.numero', 'fechaInicio', 'fechaCierre', 'usuarioApertura.nombre',
   'usuarioCierre.nombre', 'montoInicial', 'montoFinal', 'montoFinalCalculado', 'estado.value'];

  BasicFactory.setup('sesiones-cajas');

  const estadoSesiones = Filter.path('tipo.codigo').eq('estado_sesion_caja');
  const estadoSesionesUrl = encodeURI('valores?filter=' + JSON.stringify(estadoSesiones));

  var staticFilter = Filter.path('caja.id').eq($stateParams.uid);
  //var clienteFilter = Filter.path('id').eq($stateParams.uid);
  this.localModel = {};

  this.options = {
    staticFilter,
    resource: 'sesiones-cajas',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de sesiones de cajas'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'arqueoCaja.numero', title: this.translations['Número Arqueo'], defaultContent: '<i>Caja abierta</i>' },
      { data: 'fechaInicio', title: this.translations['Fecha de Inicio'], type: 'date-range', renderWith: fechaHoraRenderer },
      { data: 'fechaCierre', title: this.translations['Fecha de Cierre'], type: 'date-range', renderWith: fechaHoraRenderer },
      {
        data: 'usuarioApertura.nombre',
        title: this.translations['Usuario Apertura'],
        render: function(data, type, row) {
          var str = '';
          if (row.usuarioApertura) {
            if (row.usuarioApertura.nombre !== undefined) {
              str = str + row.usuarioApertura.nombre;
            }
            if (row.usuarioApertura.apellido !== undefined) {
              str = str + ' ' + row.usuarioApertura.apellido;
            }
          }
          return str != '' ? str : '<i>No establecido</i>';
        }
      },
      {
        data: 'usuarioCierre.nombre',
        title: this.translations['Usuario Cierre'],
        render: function(data, type, row) {
          var str = '';
          if (row.usuarioCierre) {
            if (row.usuarioCierre.nombre !== undefined) {
              str = str + row.usuarioCierre.nombre;
            }
            if (row.usuarioCierre.apellido !== undefined) {
              str = str + ' ' + row.usuarioCierre.apellido;
            }
          }
          return str != '' ? str : '<i>No establecido</i>';
        }
      },
      { data: 'montoInicial', title: this.translations['Monto Inicial'], renderWith: 'monedaRender' },
      { data: 'montoFinal', title: this.translations['Monto Final'], renderWith: 'monedaRender' },
      { data: 'montoFinalCalculado', title: this.translations['Monto Final Calculado'], renderWith: 'monedaRender' },
      {
        data: 'estado.value',
        title: this.translations['Estado'],
        type: 'combo',
        filterUrl: estadoSesionesUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.estado ? row.estado.name : '<i>No establecido</i>';
        }
      }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    canEditCondition: () => false,
    canRemoveCondition: () => false,
    canListCondition: () => false,
    canGetReporte: canGetReporte.bind(this),
    canGetReporteResumenFinanciero: canGetReporteResumenFinanciero.bind(this),
    canGetReporteArqueoCaja: canGetReporteArqueoCaja.bind(this),
    canTransacciones: canTransacciones.bind(this),
    extraRowOptions: [
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="' + this.translations['Arqueo de Caja'] + '" ng-show="options.canGetReporte(rowsData[<%= dataId %>])" ng-click="reporteArqueoCaja(<%= dataId %>)"> <span class="glyph-icon icon-list-ol" style="top: -8px;"></span></button>',
        functionName: 'reporteArqueoCaja',
        functionDef: (itemId) => {
          download('cajas', itemId, 'arqueo-caja', config, $resource, HeadersUtil, { tipo: 'pdf' });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-warning btn-dt" uib-tooltip="' + this.translations['Resumen Financiero'] + '" ng-show="options.canGetReporteResumenFinanciero(rowsData[<%= dataId %>])" ng-click="reporteResumenFinanciero(rowsData[<%= dataId %>])"> <span class="glyph-icon icon-file-text" style="top: -8px;"></span></button>',
        functionName: 'reporteResumenFinanciero',
        functionDef: (sesion) => {
          download('cajas', sesion.id, 'reporte-resumen-financiero-sesion', config, $resource, HeadersUtil, { tipo: 'pdf' });
        }
      },
      // {
      //   templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-warning btn-dt" uib-tooltip="' + this.translations['Arqueo de Cierre'] + '" ng-show="options.canGetReporteResumenFinanciero(rowsData[<%= dataId %>])" ng-click="reporteArqueoCierre(rowsData[<%= dataId %>])"> <span class="glyph-icon icon-file-text-o" style="top: -8px;"></span></button>',
      //   functionName: 'reporteCierre',
      //   functionDef: (sesion) => {
      //     download('cajas', sesion.id, 'reporte-arqueo-caja-sesion', config, $resource, HeadersUtil, { tipo: 'pdf' });
      //   }
      // },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-danger btn-dt" uib-tooltip="' + this.translations['Listado de transacciones'] + '" ng-show="options.canTransacciones(rowsData[<%= dataId %>])" ng-click="transacciones(<%= dataId %>)"> <span class="glyph-icon icon-list-ul" style="top: -8px;"></span></button>',
        functionName: 'transacciones',
        functionDef: (itemId) => {
          this.$state.go('home.cajas.uid.sesiones-cajas.eid.transacciones.list', { uid: $stateParams.uid, eid: itemId });
        }
      }
    ]
  };

  function canTransacciones(data) {
    return (data.arqueoCaja) && AuthorizationService.hasPermission('index_cajas');
  }

  function canGetReporte(data) {
    return (data.arqueoCaja) && AuthorizationService.hasPermission('index_cajas');
  }

  function canGetReporteResumenFinanciero(data) {
    return (data.arqueoCaja) && AuthorizationService.hasPermission('index_cajas');
  }

  function canGetReporteArqueoCaja(data) {
    return (data.arqueoCaja) && AuthorizationService.hasPermission('index_cajas');
  }

  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.gotoForm = gotoForm.bind(this);
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de Sesiones de Cajas']
    };
    this.form();
    //$ngRedux.dispatch(rest.actions.allClientes({ filter: JSON.stringify(clienteFilter) }));
  };

  function mapStateToThis(state) {
    this.handleStatus(state);

    /*if (state.allClientes.data && state.allClientes.data.length > 0 && !this.localModel.cliente) {
      this.localModel.cliente = state.allClientes.data[0];
    }*/

    return { form: state.form };
  }

  function handleStatus(state) {
    if (state.form.removed) {
      ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.form();
    }
    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

  }

  function gotoForm() {
    $state.go('home.cajas.uid.sesiones-cajas.new');
  }

}


// WEBPACK FOOTER //
// ./src/components/cajas/sesiones-cajas/list/sesiones-cajas.component.js